import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { IFieldDefinition, customSWRConfig } from '../../model/types';
import { collectFieldDefinition } from '../../utils/forms/customFieldsHelper';
import { notAvailableForEndUserForm } from '../../utils/forms/endUserRequestFormHelper';
import { nonNullishValue } from '../../utils/helpers';
import useConditionOptions from '../../utils/useConditionOptions';
import { getUIFriendlyTicketFieldDefinitionList } from '../ticketDetailPage/useTicketFieldDefinitionList';
import useEndUserFormById from './useEndUserFormById';
import useEndUserFormFields from './useEndUserFormFields';

export default function useFieldDefinitionListFromEndUserForm(config: customSWRConfig = {}): IFieldDefinition[] {
    const {
        query: { userFormId }
    } = useRouter();
    const { data: selectedEndUserForm } = useEndUserFormById(userFormId?.toString(), config);
    const { data } = useEndUserFormFields(config);
    const formFields = getUIFriendlyTicketFieldDefinitionList(data);
    const { localizeOptions } = useConditionOptions();

    const fields = useMemo(() => {
        if (Number.isNaN(+userFormId)) return [];

        if (!selectedEndUserForm?.fields || !formFields) {
            // console.debug(`useFieldDefinitionListFromEndUserForm, selectedEndUserForm not found for id: ${userFormId}`);
            return [];
        }

        return selectedEndUserForm?.fields
            .map(({ key }) => collectFieldDefinition(formFields.listMap)(key))
            .filter(notAvailableForEndUserForm)
            .filter(nonNullishValue)
            .map((field: IFieldDefinition) => ({
                ...field,
                options: localizeOptions(field.key as any, field.options)
            }));
    }, [formFields, localizeOptions, selectedEndUserForm?.fields, userFormId]);

    return fields;
}
